import React from "react";
import { Tabs } from "antd";
import SellLatexList from "../../components/setting-conponents/Seller/SellLatexList";
import SellLatexCCTList from "../../components/setting-conponents/Seller/SellLatexCCTList";
import SellChemicalList from "../../components/setting-conponents/Seller/SellChemicalList";
import SellChemicalModal from "../../components/setting-conponents/Seller/SellChemicalModal";
import SellLatexCCTModal from "../../components/setting-conponents/Seller/SellLatexCCTModal";
import SellLatexModal from "../../components/setting-conponents/Seller/SellLatexModal";
import SellVehicleLatexList from "../../components/setting-conponents/Seller/SellVehicleLatexList";
import { USER_GROUP } from "../../constants/string";
import { useUserContext } from "../../hooks/UserSettingProvider";

export default function SellerSettingView() {
  const [openAddSellLatexList, setOpenAddSellLatexList] = React.useState(false);
  const [openAddSellLatexCCTList, setOpenAddSellLatexCCTList] = React.useState(false);
  const [openAddSellChemicalList, setOpenAddSellChemicalList] = React.useState(false);

  const { user } = useUserContext();
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? (user.groups.find((group) => group === target) ? true : false) : true)

  const tableRef = React.useRef(null);

  const items = [
    {
      key: "freshlatex",
      label: "ผู้ขายน้ำยางสด",
      children: <SellLatexList isDone={false} ref={tableRef} />,
      permissions : (hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX))
    },
    {
      key: "vehicel",
      label: "รถน้ำยางสด",
      children: <SellVehicleLatexList ref={tableRef} />,
      permissions : (hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX))
    },
    {
      key: "latexfactory",
      label: "โรงงานผู้ขายน้ำยางข้น",
      children: <SellLatexCCTList isDone={false} ref={tableRef} />,
      permissions : (hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_CONCENTRATED))
    },
    {
      key: "chemical",
      label: "ผู้ขายสารเคมี",
      children: <SellChemicalList isDone={false} ref={tableRef} />,
      permissions : (hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_CONCENTRATED))
    },
  ];

  const refreshData = async () => {
    if (tableRef.current) {
      await tableRef.current.fetchTable();
    }
  };

  const defaultActiveTabs = items.find((item) => item.permissions == true) ? items.find((item) => item.permissions == true).key : '' ;

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey={defaultActiveTabs}
        items={items.filter((item) => item.permissions == true)}
        style={{ marginTop: 15 }}
      />
      <SellLatexModal 
        open={openAddSellLatexList}
        onClose={() => setOpenAddSellLatexList(false)}
        onUpdate={() => {
          setOpenAddSellLatexList(false);
          refreshData();
        }}
        target={null}
      />
      <SellLatexCCTModal
        open={openAddSellLatexCCTList}
        onClose={() => setOpenAddSellLatexCCTList(false)}
        onUpdate={() => {
          setOpenAddSellLatexCCTList(false);
          refreshData();
        }}
        target={null}
      />
      <SellChemicalModal
        open={openAddSellChemicalList}
        onClose={() => setOpenAddSellChemicalList(false)}
        onUpdate={() => {
          setOpenAddSellChemicalList(false);
          refreshData();
        }}
        target={null}
      />
    </div>
  );
}
